<template>
    <div class="land-prems">
        <div class="container">
            <div class="prems-column-conainer">
                <div class="col-left">
                    <div class="land-section-title" v-if="salesCardPage != null">
                        <h2>{{salesCardPage.land_site_section_titles.prems}}</h2>
                    </div>
                    <div class="prems-list">
                        <ul>
                            <li v-for="(item, index) in salesCard.project_land_site.prems_list" :key="index" :class="{'icon-list-uz': projectHost == 'kohota'}">
                                <svg-icon icon-class="check_icon_land" className="icon-check"/>
                                <p>{{item.name}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-right">
                    <div class="col-img">
                        <img :src="salesCard.project_land_site.prems_img" alt="">
                    </div>
                </div>
            </div>
            
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-prems',
        components: {
        },
        data () {
            return {
                projectHost: window.host,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-prems.scss';
     @import '@/styles/respond/sales/sales-land-partials/land-prems-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>